import React from 'react';
import PropTypes from 'prop-types';
import './styles/commuterssans_light_macroman/stylesheet.css';

const propTypes = {
  view: PropTypes.string.isRequired,
  setView: PropTypes.func.isRequired,
  updateSearchText: PropTypes.func.isRequired,
};

const Logo = () => (
  <h3 style={{
    margin: '4px 0 4px 20px',
    lineHeight: '37px',
    color: 'rgb(76, 75, 77)',
    cursor: 'pointer',
  }}
  >
    <span className="one">C</span>
    <span className="two">O</span>
    <span className="three">M</span>
    <span className="four">P</span>
    <span className="five">A</span>
    <span className="six">S</span>
    <span className="seven">S</span>
    
  </h3>
);

const LeftNav = ({ view, setView, updateSearchText }) => {
  if (view === 'home') {
    return (
      <div id="left">
        <Logo />
      </div>
    );
  }
  return (
    <div
      id="left"
      role="button"
      tabIndex={-1}
      onClick={() => {
        updateSearchText({ searchText: '' });
        setView('home');
      }}
    >
      <Logo />
    </div>
  );
};

LeftNav.propTypes = propTypes;

export default LeftNav;



// WEBPACK FOOTER //
// ./src/components/LeftNav.jsx